<!--
Copyright 2019 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <table id="audit-table" class="table">
    <thead>
      <tr>
        <th>{{ $t('header.time') }}</th>
        <th>{{ $t('header.type') }}</th>
        <th>{{ $t('header.initiator') }}</th>
        <th>{{ $t('header.target') }}</th>
        <th class="details">{{ $t('header.details') }}</th>
      </tr>
    </thead>
    <tbody v-if="audits != null">
      <audit-row v-for="audit of audits" :key="audit.key" :audit="audit"/>
    </tbody>
  </table>
</template>

<script>
import AuditRow from './row.vue';

export default {
  name: 'AuditTable',
  components: { AuditRow },
  props: {
    audits: Array // eslint-disable-line vue/require-default-prop
  }
};
</script>

<style lang="scss">
#audit-table {
  table-layout: fixed;
}
</style>

<i18n lang="json5">
{
  "en": {
    "header": {
      "time": "Time",
      "initiator": "Initiator",
      "target": "Target",
      "details": "Details"
    }
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "header": {
      "time": "Čas",
      "initiator": "Iniciátor",
      "target": "Cíl",
      "details": "Detaily"
    }
  },
  "de": {
    "header": {
      "time": "Zeit",
      "initiator": "Initiator",
      "target": "Ziel",
      "details": "Details"
    }
  },
  "es": {
    "header": {
      "time": "Hora",
      "initiator": "Iniciador",
      "target": "Objetivo",
      "details": "Detalles"
    }
  },
  "fr": {
    "header": {
      "time": "Heure",
      "initiator": "Initiateur",
      "target": "Cible",
      "details": "Détails"
    }
  }
}
</i18n>
